//@ts-nocheck
import TABLE_HEADER from "./headers";
import StatusCell from "layouts/ecommerce/orders/order-list/components/StatusCell";
import { formatCurrencyUSD } from "utils/CommonUtils";

export interface Columns {
  Header: string;
  accessor: string;
  minWidth?: number;
  Cell?: any;
}
export const COLUMNS: Columns[] = [
  {
    Header: TABLE_HEADER.APPLICATION_NO,
    accessor: "applicationNo",
    width: 170,
  },
  {
    Header: TABLE_HEADER.START_DATE,
    accessor: "applicationDate",
    width: 80,
    Cell: ({ value }) => {
      return <div style={{ display: "flex", alignItems: "center" }}>{value?.split(",")[0]}</div>;
    },
  },
  {
    Header: TABLE_HEADER.MERCHANT_NAME,
    accessor: "merchantName",
    width: 180,
  },
  {
    Header: TABLE_HEADER.STATUS,
    accessor: "status",
    width: 30,
  },
  {
    Header: TABLE_HEADER.SUB_STATUS,
    accessor: "subStatusName",
    width: 180,
    Cell: ({ value }: any) => {
      let status;

      if (value === "Approved") {
        status = <StatusCell icon="done" color="success" status={value} />;
      } else if (value === "Declined") {
        status = <StatusCell icon="close" color="error" status={value} />;
      } else {
        status = <StatusCell icon="cached" color="dark" status={value} />;
      }

      return status;
    },
  },
  {
    Header: TABLE_HEADER.USER,
    accessor: "representativeName",
    width: 150,
  },
  {
    Header: TABLE_HEADER.FUNDED,
    accessor: "fundedAmount",
    width: 30,
  },
  {
    Header: TABLE_HEADER.NET_FUNDED,
    accessor: "netFundingAmount",
    width: 30,
  },
  {
    Header: TABLE_HEADER.FACTOR,
    accessor: "paybackFactor",
    width: 30,
  },
  {
    Header: TABLE_HEADER.FUNDER,
    accessor: "funder",
    width: 100,
  },
  {
    Header: TABLE_HEADER.BROKER,
    accessor: "broker",
    width: 80,
  },
  {
    Header: TABLE_HEADER.BANK_FEES,
    accessor: "bankFees",
    width: 30,
  },
  {
    Header: TABLE_HEADER.COMMISSION,
    accessor: "commissions",
    width: 30,
  },
  {
    Header: TABLE_HEADER.OWNER_NAMES,
    accessor: "ownerNames",
    minWidth: 200,
  },
  {
    Header: TABLE_HEADER.AFFILIATED_BUSINESSES,
    accessor: "affiliatedBusinessNames",
    minWidth: 200,
  },

  {
    Header: TABLE_HEADER.DBAS,
    accessor: "dbaNames",
    width: 150,
  },
];

export default COLUMNS;
